export default __webpack_public_path__ + "static/video-screencap-943c13e28627ab1e7b91208ca860cebe.jpg";